export const config = {
    core: {
        server_address: 'https://devapi.elevatustesting.xyz/api/recruiter/v1',
        ws_address: 'ws://test.com',
        organizationsId: '',
        applicationId: '',
        server_port: '80',
    },
    getaway: {
        server_address: 'http://getaway.elevatus.com',
        ws_address: 'ws://test.com',
        organizationsId: '',
        applicationId: '',
        server_port: '80',
    },
    sentry: {
        reactAppSentryDSN: '',
        reactAppENV: '',
        version: '1.0.0',
    },
};
